module.exports = __webpack_public_path__ + "media/logos/lexshares-diamond-5957010c.png";